import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import { useSelector } from 'react-redux';
import h from '../../helpers/common';
import { useWatchAgain } from '../../hooks/data/useWatchAgain';
import { transformVOD } from '../../utils/vodTransformer';
import { GenericVodCarousel } from './GenericVodCarousel';
import { useConfigurationSections } from '../../hooks/useConfiguration';

type MpxFeedCarouselProps = {
    carousel: Carousel;
    data?: any;
};

export const WatchAgainCarousel: React.FC<MpxFeedCarouselProps> = ({ carousel }) => {
    // Using React Query instead of Redux for configuration
    const { config } = useConfigurationSections();
    const { data, isLoading, error } = useWatchAgain(carousel);

    // Early return if there's an error
    if (error) {
        return;
    }

    // Only render if we have data or are loading
    if (isLoading || data?.entries?.length) {
        return (
            <GenericVodCarousel
                isLoading={isLoading}
                language={h.getLang()}
                content={data?.entries?.map((e) => transformVOD(e, config.promotionProviderImages))}
                id={carousel.id}
                title={carousel.title_resource_key}
                name={carousel.id}
                params={{ items_count: data?.entries?.length, filter_params: carousel.dataSources }}
                data_stream={carousel.id}
                meta={{ title: { en: carousel.title_resource_key, ar: carousel.title_resource_key } }}
                carousel={carousel}
            />
        );
    }

    // If no data and not loading, return null
    return null;
};
